import React from "react";

const gradientHeader = {
  background: "linear-gradient(90deg, #00858F 0%, #E6007E 100%)",
};

const PavelPowerTable: React.FC = () => {
  return (
      <div
          data-aos="fade-zoom-in"
          data-aos-offset="200px"
          data-aos-delay="300"
          data-aos-easing="ease-in-sine"
          data-aos-duration="600"
          className="px-4 md:px-0"
      >
        <h3 className="text-center uppercase font-bold text-white text-sm tracking-widest mb-4">
          POWER SPECIFICATION PER WING (BOL)*
        </h3>

        {/* ── Desktop: SIZE as rows, deployable config as columns ── */}
        <table className="hidden md:table w-full border border-white/20 text-sm uppercase text-white">
          <thead>
          <tr style={gradientHeader}>
            <th className="px-4 py-3 text-left font-bold tracking-wider">SIZE</th>
            <th className="px-4 py-3 text-center font-bold tracking-wider">SINGLE<br />DEPLOYABLE</th>
            <th className="px-4 py-3 text-center font-bold tracking-wider">DOUBLE<br />DEPLOYABLE</th>
            <th className="px-4 py-3 text-center font-bold tracking-wider">TRIPLE<br />DEPLOYABLE</th>
          </tr>
          </thead>
          <tbody>
          <tr className="border-t border-white/20 bg-white/5">
            <td className="px-4 py-4 font-bold">6U / 12U</td>
            <td className="px-4 py-4 text-center">19W</td>
            <td className="px-4 py-4 text-center">38W</td>
            <td className="px-4 py-4 text-center">57W</td>
          </tr>
          <tr className="border-t border-white/20 bg-white/10">
            <td className="px-4 py-4 font-bold">8U / 16U</td>
            <td className="px-4 py-4 text-center">24W</td>
            <td className="px-4 py-4 text-center">48W</td>
            <td className="px-4 py-4 text-center">72W</td>
          </tr>
          </tbody>
        </table>

        {/* ── Mobile: deployable config as rows, SIZE as columns (transposed) ── */}
        <table className="md:hidden w-full border border-white/20 text-sm uppercase text-white">
          <thead>
          <tr style={gradientHeader}>
            <th className="px-3 py-3 text-left font-bold tracking-wider">CONFIG</th>
            <th className="px-3 py-3 text-center font-bold tracking-wider">6U / 12U</th>
            <th className="px-3 py-3 text-center font-bold tracking-wider">8U / 16U</th>
          </tr>
          </thead>
          <tbody>
          <tr className="border-t border-white/20 bg-white/5">
            <td className="px-3 py-3 font-bold">SINGLE</td>
            <td className="px-3 py-3 text-center">19W</td>
            <td className="px-3 py-3 text-center">24W</td>
          </tr>
          <tr className="border-t border-white/20 bg-white/10">
            <td className="px-3 py-3 font-bold">DOUBLE</td>
            <td className="px-3 py-3 text-center">38W</td>
            <td className="px-3 py-3 text-center">48W</td>
          </tr>
          <tr className="border-t border-white/20 bg-white/5">
            <td className="px-3 py-3 font-bold">TRIPLE</td>
            <td className="px-3 py-3 text-center">57W</td>
            <td className="px-3 py-3 text-center">72W</td>
          </tr>
          </tbody>
        </table>

        <p className="text-xs text-white/50 mt-3 text-center uppercase">
          *Power specifications are calculated based on Azur Space’s solar cell assemblies 3G30A in 8S2P configuration (6/12U) and 10S2P (8/16U). Configurations with different solar cells are available upon request.
        </p>
      </div>
  );
};

export default PavelPowerTable;
